import {createSlice} from '@reduxjs/toolkit';

// {"usages":{"Bandwidth":44913586,"Requests":287},"limits":{"Bandwidth":36507222016,"Transformation Background Removal":100,"Storage":2147483648}}

interface UsageInterface {
    bandwidth: number;
    storage: number;
    height: number;
    width: number;
    padding: number;
    quality: number;
    format: number;
    remove_background: number;
    rotation: number;
    grayscale: number;
}

interface LimitInterface {
    bandwidth: number;
    storage: number;
    requests: number;
    background_removal: number;
}

interface MetricsInterface {
    isLoading: boolean;
    error: any;
    usages: UsageInterface;
    limits: LimitInterface;
    isDefault: boolean;
    balance: number;
}

const DefaultState: MetricsInterface = {
    isLoading: false,
    error: null,
    isDefault: true,
    balance: 0,
    usages: {
        bandwidth: 0,
        storage: 0,
        height: 0,
        width: 0,
        padding: 0,
        quality: 0,
        format: 0,
        remove_background: 0,
        rotation: 0,
        grayscale: 0,
    },
    limits: {
        bandwidth: 0,
        storage: 0,
        requests: 0,
        background_removal: 0,
    },
};

const MetricsSlice = createSlice({
    name: 'metrics',
    initialState: DefaultState,
    reducers: {
        metricsDataRequest: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        metricsDataSuccess: (state, action) => {
            state.usages = action.payload.usages;
            state.limits = action.payload.limits;
            state.isLoading = false;
            state.isDefault = false;
        },
        metricsDataFailure: (state, action) => {
            state.isLoading = false;
            state.error = 'metrics data failure';
        },
        metricsWalletDataSuccess: (state, action) => {
            state.balance = action.payload.balance;
            state.isLoading = false;
            state.isDefault = false;
        },
        metricsWalletDataFailure: (state, action) => {
            state.isLoading = false;
            state.error = 'metrics wallet data failure';
        },
    },
});

const {metricsDataRequest, metricsDataSuccess, metricsDataFailure, metricsWalletDataSuccess, metricsWalletDataFailure} =
    MetricsSlice.actions;

export {metricsDataRequest, metricsDataSuccess, metricsDataFailure, metricsWalletDataSuccess, metricsWalletDataFailure};

export default MetricsSlice.reducer;
